import { FC } from 'react';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import { useReclassificationModal } from '../context/ReclassificationModalContext';
import RangeRow from './RangeRow';

const RangesView: FC = () => {
  const { data, actions } = useReclassificationModal();

  const hasData = data.ranges && data.ranges.length > 0;

  return (
    <>
      {data.ranges.map((range, index) => (
        <div className="form-control-wrap" key={`row-${range.key}`}>
          <RangeRow index={index} range={range} />
        </div>
      ))}

      {hasData && (
        <div className="mt-1">
          <TablePagination
            totalRows={data.totalRanges || 0}
            onChangePage={actions.handleChangePage}
            onChangeRowsPerPage={actions.handleChangeRowsPerPage}
          />
        </div>
      )}
    </>
  );
};

export default RangesView;
